/* ══════════════════════════════════════════════════════════════════
   上传框 `.eb-upl` —— **表单套件的一件，不属于任何一页。**
   联系页、门店申请、达人申请三张表共用这一份。

   ⚠️ 这一件和主题里其他 JS 的性质不一样：**没有它，上传这一块根本不成立。**
   `{% form 'contact' %}` 收不了附件 —— 这是平台限制，不是漏做。所以文件
   不随表单走，而是**选中之后立刻异步传到 section 设置里那个端点**，
   传回来的链接写进隐藏字段，跟着邮件正文到收件箱。

   正因为如此，那一块由两个设置项控制、**端点没配就整块不渲染**：
   一个悄悄丢掉照片的上传框比没有更糟，这条纪律没有松，
   只是现在有了不用触犯它的办法。

   端点约定（写在设置说明里，也写在这）：
     收  一个 `file` 字段的 multipart POST，一次一个文件
     回  JSON，带 `url` / `file_url` / `location` / `src` 任意一个
           另外**可选**：`type`（image|video）、`poster`（视频首帧）、`duration`（秒）
           —— 只有缩略图形制用得上，不给也不会坏，见下
     ⚠️ 回了 200 但没给链接**算失败** —— 拿不到链接的成功是最坏的一种

   挂载点：`[data-ct-upload]`，里面要有
     `input[type=file]` · `[data-ct-upload-list]` · `[data-ct-upload-field]`

   ── 两种清单形制 ────────────────────────────────────────────
   默认（发票、PDF、行驶证）画「文件名 ＋ 进度 ＋ 大小 ＋ 删除」：
   一份 PDF 的文件名就是它的全部内容。

   `data-ct-upload-mode="media"`（账户评价那一节）画方格缩略图 ——
   那里传的是他刚拍的东西，要确认的是「我选中的是不是那一张」，
   而 `IMG_4821.HEIC` 回答不了这个问题。
   **两种形制共用同一份状态**：items 仍然是唯一的真相，上传、进度、
   超量超大、传到一半 abort、隐藏字段，一行都没分叉 —— 分叉的只有 draw()。
   ══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* ══ 上传 ══════════════════════════════════════════════════════
     一个 box 管一份文件清单。清单是**唯一的真相**：列表、隐藏字段
     都从它画出来，删一个就重画一次。别去改 `input.files` —— 那条路
     在 Safari 上要靠 DataTransfer，而我们根本不需要它：文件不随表单走。 */
  function bytes(n) {
    return n < 1048576 ? Math.round(n / 1024) + ' KB' : (n / 1048576).toFixed(1) + ' MB';
  }

  function upload(box, item, done) {
    var body = new FormData();
    body.append('file', item.file, item.file.name);

    var xhr = new XMLHttpRequest();
    item.xhr = xhr;
    xhr.open('POST', box.dataset.url, true);
    xhr.responseType = 'json';

    /* 进度是真的进度：手机上一张 8 MB 的照片要传十几秒，
       一个转圈只说明「还活着」，不说明还要等多久。 */
    xhr.upload.addEventListener('progress', function (e) {
      if (!e.lengthComputable) return;
      item.pct = Math.round((e.loaded / e.total) * 95);
      done();
    });

    xhr.addEventListener('load', function () {
      var data = xhr.response;
      if (typeof data === 'string') {
        try { data = JSON.parse(data); } catch (err) { data = { url: data }; }
      }
      /* 端点各家回的字段名不一样，认这四个里的任意一个。
         回了 200 但没给链接**算失败** —— 拿不到链接的成功是最坏的一种。 */
      var url = data && (data.url || data.file_url || data.location || data.src);
      if (xhr.status >= 200 && xhr.status < 300 && url) {
        item.url = url;
        item.pct = 100;
        /* 缩略图形制要用的三样，端点给了就收下。**一个都不是必须的** ——
           type 猜得出来（扩展名），poster 不给就退回本地那一帧，
           duration 不给就不画时长。少了只是角标不好看，不是坏。 */
        if (data.type) item.type = data.type;
        if (data.poster) item.poster = data.poster;
        if (data.duration) item.duration = data.duration;
      } else {
        item.error = true;
      }
      done();
    });

    xhr.addEventListener('error', function () { item.error = true; done(); });
    xhr.addEventListener('abort', function () { item.error = true; done(); });
    xhr.send(body);
  }

  function wireUpload(box) {
    if (box.dataset.ctUploadReady) return;
    box.dataset.ctUploadReady = '1';

    var input = box.querySelector('input[type="file"]');
    var list = box.querySelector('[data-ct-upload-list]');
    var field = box.querySelector('[data-ct-upload-field]');
    var zone = box.querySelector('.eb-upl__zone');
    var cap = parseInt(box.dataset.cap, 10) || 3;
    var max = (parseInt(box.dataset.max, 10) || 10) * 1048576;
    var items = [];
    var over = false;
    /* 形制只有一处开关，其余全部共用。**分叉只在 draw()** ——
       上传、进度、超量超大、abort、隐藏字段一行都没有第二份实现。 */
    var media = box.dataset.ctUploadMode === 'media';
    if (media) box.classList.add('eb-upl--media');

    /* 隐藏字段：只有传成功的才写进去，**一个都没有就 disabled** ——
       空的 `contact[Attachments]` 会在每封邮件里多出一行空的。 */
    function urls() {
      return items.filter(function (it) { return it.url; }).map(function (it) { return it.url; });
    }

    /* 超量那句话：方格版挂在整块末尾，清单版挂在清单末尾。
       **每次重画都要跟着回来** —— 写在 draw 外面的话，
       下一次进度回调就把它擦了。 */
    function note() {
      var el = box.querySelector('[data-ct-upload-over]');
      if (el) el.remove();
      if (over) {
        box.insertAdjacentHTML(
          'beforeend',
          '<p class="eb-upl__note" data-ct-upload-over>' + box.dataset.tMany + '</p>'
        );
      }
    }

    /* 文件名进 innerHTML 之前先转义。名字是本地来的，风险不高，
       但一个带尖括号的文件名会把这一行的 HTML 撕开。 */
    function esc(s) {
      return String(s).replace(/[&<>"]/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
      });
    }

    /* ══ 缩略图形制 ══════════════════════════════════════════
       本地预览用 `URL.createObjectURL`，**不等端点回链接** ——
       手机上一张 8 MB 的照片要传十几秒，这十几秒里格子里得有东西，
       否则人只会看见四个灰方块，不知道自己选对没有。
       端点回了 `poster` 再换成它（视频尤其：本地那一帧要解码整个文件头）。

       ⚠️ objectURL 必须 revoke。一次评价传六段视频，不撤就是六份文件
       留在内存里直到刷新 —— 手机上这足够让页面被系统回收掉。 */
    function localSrc(it) {
      if (it.src) return it.src;
      try {
        it.src = URL.createObjectURL(it.file);
      } catch (err) {
        it.src = '';
      }
      return it.src;
    }

    function isVideo(it) {
      if (it.type) return it.type === 'video';
      return /^video\//.test(it.file.type);
    }

    function clock(sec) {
      var m = Math.floor(sec / 60);
      var r = Math.round(sec % 60);
      return m + ':' + (r < 10 ? '0' : '') + r;
    }

    function tile(it, i) {
      var kill =
        '<button type="button" class="eb-upl__kill" data-i="' + i + '" aria-label="' +
        esc(box.dataset.tRemove + ' ' + it.file.name) + '">' +
        '<svg class="eb-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" ' +
        'stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true">' +
        '<path d="M18 6 6 18M6 6l12 12"/></svg></button>';

      /* 太大 / 端点出错：**就地说清楚是哪一格**，不弹窗也不拦下整张表。
         附件本来就是可选的，为一段太大的视频挡住一份评价不值得。 */
      if (it.error) {
        return '<li class="eb-upl__tile" data-state="bad">' +
          '<span class="eb-upl__bad">' +
          (it.file.size > max ? box.dataset.tBig : box.dataset.tFailed) +
          '</span>' + kill + '</li>';
      }

      var src = it.poster || localSrc(it);
      var vid = isVideo(it);
      var media = vid && !it.poster
        ? '<video src="' + esc(src) + '" muted playsinline preload="metadata"></video>'
        : '<img src="' + esc(src) + '" alt="' + esc(it.file.name) + '">';
      var busy = !it.url;

      return '<li class="eb-upl__tile"' + (busy ? ' data-state="up"' : '') + '>' +
        media +
        (busy
          ? '<span class="eb-upl__pct">' + (it.pct || 0) + '%</span>' +
            '<span class="eb-upl__prog"><i style="width:' + (it.pct || 4) + '%"></i></span>'
          : vid
            ? '<span class="eb-upl__vid">' +
              '<svg width="9" height="9" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' +
              '<path d="M8 5.2v13.6L19 12z"/></svg>' +
              (it.duration ? clock(it.duration) : '') + '</span>'
            : '') +
        kill + '</li>';
    }

    function draw() {
      if (media) {
        list.innerHTML = items.map(tile).join('');
        /* 满了就把「再加几个」那一格收起来 —— 一个点了不会有反应的加号，
           人只会一直点。超量那句话仍然由下面的 note 说。 */
        if (zone) zone.hidden = items.length >= cap;
        field.value = urls().join('\n');
        field.disabled = field.value === '';
        note();
        return;
      }
      list.innerHTML = items
        .map(function (it, i) {
          var state = it.error
            ? (it.file.size > max ? box.dataset.tBig : box.dataset.tFailed)
            : it.url
              ? box.dataset.tAttached
              : box.dataset.tSending;
          return (
            '<li class="eb-upl__file"' + (it.error ? ' data-bad' : '') + '>' +
            '<svg class="eb-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
            'stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<path d="M13.5 3.5H7a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V9z"/><path d="M13.5 3.5V9H19"/>' +
            '</svg>' +
            '<span class="eb-upl__nm">' + esc(it.file.name) + '</span>' +
            (it.url || it.error
              ? ''
              : '<span class="eb-upl__bar"><i style="width:' + (it.pct || 4) + '%"></i></span>') +
            '<span class="eb-upl__state">' + state + ' · ' + bytes(it.file.size) + '</span>' +
            '<button type="button" class="eb-upl__x" data-i="' + i + '" aria-label="' +
            esc(box.dataset.tRemove + ' ' + it.file.name) + '">' +
            '<svg class="eb-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
            'stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>' +
            '</button></li>'
          );
        })
        .join('');

      /* 超量那一句挂在清单末尾，**每次重画都要跟着回来** ——
         它写在 draw 外面的话，下一次进度回调就把它擦了。 */
      if (over) list.insertAdjacentHTML('beforeend', '<li class="eb-upl__note">' + box.dataset.tMany + '</li>');

      field.value = urls().join('\n');
      field.disabled = field.value === '';
    }

    function add(files) {
      [].slice.call(files).forEach(function (file) {
        /* 超量和超大都**就地说清楚**，不弹窗也不拦下整张表：
           附件本来就是可选的，为一张太大的照片挡住一封信不值得。 */
        if (items.length >= cap) {
          over = true;
          return;
        }
        var item = { file: file, pct: 0 };
        items.push(item);
        if (file.size > max) {
          item.error = true;
          return;
        }
        upload(box, item, draw);
      });
      draw();
    }

    input.addEventListener('change', function () {
      add(input.files);
      /* 清空 input：同一个文件连选两次也要能进来，
         而且我们的真相在 items 里，不在 input 上。 */
      input.value = '';
    });

    list.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-i]');
      if (!btn) return;
      var it = items.splice(+btn.dataset.i, 1)[0];
      /* 传到一半删掉就把请求掐了。**端点上那个文件不去删** ——
         删它要一个我们没有的凭证，而一个没人引用的文件是端点自己的事。 */
      if (it && it.xhr && !it.url) it.xhr.abort();
      /* objectURL 必须撤。一次评价传六段视频，不撤就是六份文件留在内存里
         直到刷新 —— 手机上这足够让页面被系统回收掉。 */
      if (it && it.src) URL.revokeObjectURL(it.src);
      if (items.length < cap) over = false;
      draw();
    });

    ['dragenter', 'dragover'].forEach(function (type) {
      zone.addEventListener(type, function (e) { e.preventDefault(); zone.dataset.drag = 'on'; });
    });
    ['dragleave', 'drop'].forEach(function (type) {
      zone.addEventListener(type, function (e) { e.preventDefault(); delete zone.dataset.drag; });
    });
    zone.addEventListener('drop', function (e) {
      if (e.dataTransfer && e.dataTransfer.files.length) add(e.dataTransfer.files);
    });
  }

  function init() {
    document.querySelectorAll('[data-ct-upload]').forEach(wireUpload);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* 编辑器里换设置会重画整个 section —— 重画之后新的那个框还没接线。
     `wireUpload` 自带 `data-ct-upload-ready` 挡重复，接两次不会有两份清单。 */
  document.addEventListener('shopify:section:load', init);
})();
